module.exports = __webpack_public_path__ + "static/img/1.421d76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userMethods/1.png
// module id = 2X9f
// module chunks = 0